import React, { useEffect, useState, useMemo  } from "react";

/**
 * Simple debounced text input.
 *
 * Props:
 * - value (string) - initial value (optional)
 * - onChange (fn) - called with (newValue) after debounce
 *
 *
 * - placeholder (string) - input placeholder
 * - debounceMs (number) - debounce interval (default 200)
 */
export default function FileFilterInput({
    value: initial = "",
    onChange,
    placeholder = "Filter files...",
    debounceMs = 200,
    className = "",
    inputProps = {}

}) {
    const [value, setValue] = useState(initial);

  // local debounced effect
  useEffect(() => {
     const id = setTimeout(() => {
      if (typeof onChange === "function") onChange(value);
     }, debounceMs);
     return () => clearTimeout(id);
  }, [value, onChange, debounceMs]);

  // allow parent to reset input easily by changing initial prop
  useEffect(() => {
     setValue(initial);
     }, [initial]);

  return (
    <div className={`file-filter-input ${className}`}>
      <input
        type="search"
        aria-label="Filter files"
        placeholder={placeholder}
        value={value}
        onChange={(e) => setValue(e.target.value)}
        {...inputProps}
        style={{
          width: "100%",
          boxSizing: "border-box",
          padding: "6px 8px",
          borderRadius: 6,
          border: "1px solid var(--border-color, #ddd)"
        }}
      />
    </div>
  );
}
